#import "../fragments/sales-automation-stageset.graphql"

mutation CreateClosedLeadEmailAutomation(
    $emailAutomation: CreateClosedLeadEmailAutomationInputFieldInput!
) {
    createClosedLeadEmailAutomation(input: {emailAutomation: $emailAutomation}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
